<template>
  <div v-if="show" class="common-overlay" style="position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; background-color: rgba(0, 0, 0, 0.7) !important; display: flex !important; justify-content: center !important; align-items: center !important; z-index: 9999999 !important;">
    <div class="common-overlay-content" style="background-color: white !important; border-radius: 8px !important; padding: 30px !important; text-align: center !important; max-width: 90% !important; width: 400px !important; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2) !important; z-index: 9999999 !important;">
      <div class="spinner-container" style="margin-bottom: 20px !important;">
        <div class="spinner" style="display: inline-block !important; width: 60px !important; height: 60px !important; border: 5px solid rgba(0, 123, 255, 0.2) !important; border-radius: 50% !important; border-top-color: #007bff !important; animation: spin 1s ease-in-out infinite !important;"></div>
      </div>
      <h3 class="overlay-title" style="font-size: 24px !important; margin-bottom: 15px !important; color: #333 !important;">{{ title }}</h3>
      <p class="overlay-message" style="font-size: 16px !important; color: #666 !important; margin-bottom: 0 !important;">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonOverlay',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Loading'
    },
    message: {
      type: String,
      default: 'Please wait while we load the content...'
    }
  },
  /* mounted() {
    console.log('CommonOverlay component mounted');
  } */
}
</script>

<style scoped>
.common-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.common-overlay-content {
  background-color: white;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  max-width: 90%;
  width: 400px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.spinner-container {
  margin-bottom: 20px;
}

.spinner {
  display: inline-block;
  width: 60px;
  height: 60px;
  border: 5px solid rgba(0, 123, 255, 0.2);
  border-radius: 50%;
  border-top-color: #007bff;
  animation: spin 1s ease-in-out infinite;
}

.overlay-title {
  font-size: 24px;
  margin-bottom: 15px;
  color: #333;
}

.overlay-message {
  font-size: 16px;
  color: #666;
  margin-bottom: 0;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
